import Vue from "vue";
import { Component } from "vue-property-decorator";
import { validations, validationMessages } from "./validations";
import * as icons from "@/components/icons";
import {
    ICountry,
} from "@/models";
import { Validation } from "vuelidate";

@Component({
    name: "countries",
    validations,
    components: {
        "add-icon": icons.AddIcon,
        "edit-icon": icons.EditIcon,
        "save-icon": icons.SaveIcon,
        "delete-icon": icons.DeleteIcon,
    },
})

export default class Countries extends Vue {
    public loadPromises: Array<Promise<any>>;
    public countryId: number;
    public countrySearch: string;
    public countryName: string;
    public countryValue: string;
    public editingCountryName: string;
    public editingCountryValue: string;
    public editingCountryId: number;

    constructor() {
        super();

        this.loadPromises = [];
        this.countryId = null;
        this.countrySearch = "";
        this.countryName = "";
        this.countryValue = "";
        this.editingCountryName = "";
        this.editingCountryValue = "";
        this.editingCountryId = 0;

        if (!this.$store.state.request.isReferenceDataLoaded) {
            this.loadPromises.push(this.$store.dispatch("request/fetchReferenceData"));
        }
    }

    public async addCountry(): Promise<void> {
        if (this.validateBeforeSave(this.$v.countryName) && this.validateBeforeSave(this.$v.countryValue)) {
            await this.$store.dispatch("request/addCountry", {
                Name: this.countryName,
                Value: this.countryValue,
            });

            this.countryName = "";
            this.countryValue = "";
            this.$v.countryName.$reset();
            this.$v.countryValue.$reset();
        }
    }

    public get validationMessages(): { [key: string]: string } {
        return validationMessages;
    }

    public async editCountry(country: ICountry): Promise<void> {
        this.editingCountryId = country?.countryId ?? 0;
        this.editingCountryName = country?.name ?? "";
        this.editingCountryValue = country?.value ?? "";
    }

    public async saveEditCountry(country: ICountry): Promise<void> {
        if (this.validateBeforeSave(this.$v.editingCountryName)
                && this.validateBeforeSave(this.$v.editingCountryValue)) {
            this.editingCountryId = 0;
            country.name = this.editingCountryName;
            country.value = this.editingCountryValue;
            await this.$store.dispatch("request/saveEditCountry", country);
            this.editingCountryName = "";
            this.editingCountryValue = "";
            this.$v.editingCountryName.$reset();
            this.$v.editingCountryValue.$reset();
        }
    }

    public async deleteCountry(countryId: number): Promise<void> {
        await this.$store.dispatch("request/deleteCountry", countryId);
    }

    public get countries(): ICountry[] {
        return this.$store.getters["request/getFilteredCountries"](this.countrySearch);
    }

    public validateBeforeSave(rules: Validation): boolean {
        rules.$touch();
        return !rules.$invalid;
    }
}

